import {
    APPLICANT,
    DRAFT,
    CCO,
    CLUSTER_ADMIN,
    DISTRIBUTED,
    REVIEWED,
    SECRETARY,
    SUBMITTED,
    VERIFIED,
    RE_SUBMITTED,
    CONFIRMED,
    FOR_REVIEW,
    RETURN_FROM_IRB,
    RETURNED,
    REQUEST_FOR_RETURN,
    IRB,
    REVIEWER,
    APPROVED,
    WITHDRAWN,
    TERMINATED,
    COMPLETED,
    ACKNOWLEDGED,
    DISAPPROVED,
    TAB_CONSOLIDATION,
    TAB_REVIEWER_COMMENT,
    KEY_PATHNAME,
    EXPIRED,
} from 'utility/lookup';
import { CTC, CTI, PostApprovalFormType } from 'utility/postApprovalLookUp';
import { useDispatch, useSelector } from 'react-redux';
import useDialog from 'components/ConfirmDialog/useDialog';
import { useHistory } from 'react-router';
import api from 'api/call';
import {
    CONFIRM_REQUEST_TO_RETURN_CONFIRM,
    GENERAL_CONFIRM,
    GENERAL_CONFIRM_SUCCESS,
    POST_APPROVAL_DISCARD_TIPS,
    GENERAL_DISTRIBUTE_SUCCESS,
    GENERAL_DISTRIBUTE_TIPS,
    GENERAL_RETURN_SUCCESS,
    GENERAL_RETURN_TIPS,
    GENERAL_VERIFY_SUCCESS,
    GENERAL_VERIFY_TIPS,
    GENERAL_WITHDRAWN_SUCCESS,
    GENERAL_WITHDRAWN_TIPS,
    REJECT_RETURN_OF_REQUEST_TIPS,
    REJECT_SUCCESS,
    CONSOLIDATION_SAVED,
    GENERAL_CONSOLIDATION_SUCCESS,
    POST_APPROVAL_SAVE_BEFORE_PRINT,
    FORM_SAVE_BEFORE_PRINT,
    CONFIRM_RETURN_TO_CLUSTER_ADMIN,
    GENERAL_SUBMIT_TIPS,
    GENERAL_RE_SUBMIT_TIPS,
    GENERAL_SAVE_TIPS,
    PLEASE_COMPLETE_THE_FORM,
    DISCARD_CONFIRM,
    POST_APPROVAL_DISCARD_SUCCESS,
} from 'utility/frontendMessage';
import useCommentDialog from 'components/CommentDialog/useCommentDialog';
import { setGlobal, setGlobalLoading } from 'store/global/reducer';
import { getFolderDisplayPath, postApprovalPermissionChecking } from 'utility/general';
import {
    SUBMIT_CONSOLIDATION_DETAIL,
    SAVE_CONSOLIDATION_DETAIL,
    DOWNLOAD_APPROVAL_LETTER,
    GET_DOWNLOAD_DOCUMENT,
} from 'store/key';
import API from 'api/call';
import { returnCondition } from 'utility/formValidate';
import { getItem } from 'storage';

const useGeneralPostApprovalButton = ({
    submissionId,
    formType,
    formTab,
    isFormCreate,
    onCreate = () => {},
    onSubmit = () => {},
    status,
    reportId,
    isViewOnly,
    hasCCOAction,
    switchToTab = () => {},
    onSignedDocumentUploaded = () => {},
    user,
    currentTab,
    signedUpload,
    checkIsFormDataChanged = () => null,
    checkSubmitFormValid = () => {
        return { valid: true, msg: '' };
    },
    checkSaveFormValid = () => {
        return { valid: true, msg: '' };
    },
    reSubmitCTCAndCTI,
    hasPermission,
}) => {
    const showDialog = useDialog();
    const showCommentDialog = useCommentDialog();
    const userRole = useSelector((state) => state.user.role);
    const history = useHistory();
    const dispatch = useDispatch();
    const postApprovalFolder = useSelector((state) => state.postApproval.folder || 'all');

    const systemMessage = useSelector((state) => state.systemMessage.systemMessage);
    const documentType = formType;

    let result = [];

    // cluster for distribute action, expiryDate for request for return / return action
    const updateStatus = ({ status, comment, uploadTempId }) => {
        return api.postApprovalActivities.updateStatusCommon({
            docType: formType,
            docId: reportId,
            updateStatus: status,
            comment,
            uploadTempId,
        });
    };

    const returnDocument = ({ status, comment, uploadTempId, expiryDate }) => {
        return api.postApprovalActivities.returnDocument({
            docType: formType,
            docId: reportId,
            updateStatus: status,
            comment,
            uploadTempId,
            expiryDate,
        });
    };

    const distributeDocument = ({ status, comment, uploadTempId, cluster }) => {
        return api.postApprovalActivities.distributeDocument({
            docType: formType,
            docId: reportId,
            updateStatus: status,
            comment,
            uploadTempId,
            cluster,
        });
    };

    const rejectRequestForRequest = ({ comment, uploadTempId }) => {
        return api.postApprovalActivities.rejectRequestForRequest({
            docType: formType,
            docId: reportId,
            comment,
            uploadTempId,
        });
    };

    const consolidationStatus = [FOR_REVIEW, TERMINATED, COMPLETED, REVIEWED, ACKNOWLEDGED, DISAPPROVED, APPROVED];

    result = [
        {
            text: 'Print',
            status: [DRAFT, RETURNED],
            action: async () => {
                const downloadFunc = (newReportId) => {
                    setGlobalLoading(true);
                    dispatch({
                        type: GET_DOWNLOAD_DOCUMENT,
                        payload: {
                            data: {
                                docType: documentType,
                                docId: newReportId ?? reportId,
                            },
                            apiUrl: API.postApprovalActivities.generateReport,
                            final: () => setGlobalLoading(false),
                        },
                    });
                };

                if (checkIsFormDataChanged() || !reportId) {
                    const isSave = await showDialog({
                        description: !reportId ? FORM_SAVE_BEFORE_PRINT : POST_APPROVAL_SAVE_BEFORE_PRINT,
                    });
                    if (isSave) {
                        onCreate({
                            callback: (newReportId) => {
                                downloadFunc(newReportId);
                            },
                        });
                    }
                    return;
                }
                downloadFunc();
            },
            showInRoles: [APPLICANT],
            showInFormCreate: true,
            disableInForm: [CTC, CTI],
            showInTab: [PostApprovalFormType.FORM],
        },
        {
            text: 'Upload Signed Document',
            status: [DRAFT, RETURNED],
            action: (apiResult) => {
                onSignedDocumentUploaded({ ...apiResult[0], isNewUpload: true });
            },
            condition: () => {
                //case of view only of applicant
                // if (userRole === APPLICANT && status === RETURNED) {
                //     return hasPermission;
                // }
                return !isViewOnly;
            },
            showInRoles: [APPLICANT],
            showInFormCreate: true,
            disableInForm: [CTC, CTI],
            showInTab: [PostApprovalFormType.FORM],
        },
        {
            text: 'Save',
            status: [DRAFT, RETURNED],
            action: async () => {
                const result = await checkSaveFormValid();

                if (!result) {
                    return;
                }

                const { valid, msg } = result;

                if (!valid) {
                    return showDialog({
                        description: msg ?? PLEASE_COMPLETE_THE_FORM,
                        disableCancelButton: true,
                    });
                }

                const isConfirm = await showDialog({
                    description: GENERAL_SAVE_TIPS,
                });

                if (isConfirm) {
                    onCreate({});
                }
            },
            showInFormCreate: true,
            showInRoles: [APPLICANT],
            showInTab: [PostApprovalFormType.FORM],
            condition: () => {
                //case of view only of applicant

                return !isViewOnly;
            },
        },
        {
            text: 'Submit',
            status: [DRAFT, RETURNED],
            action: async () => {
                const result = await checkSubmitFormValid();

                if (!result) {
                    return;
                }

                const { valid, msg } = result;

                if (!valid) {
                    return showDialog({
                        description: msg ?? PLEASE_COMPLETE_THE_FORM,
                        disableCancelButton: true,
                    });
                }
                if (!signedUpload?.fileName) {
                    return showDialog({
                        description: 'Please upload the signed document before submission',
                        disableCancelButton: true,
                    });
                }

                const isConfirm = await showDialog({
                    description: GENERAL_SUBMIT_TIPS,
                });

                if (isConfirm) {
                    onSubmit({ isResubmit: false });
                }
            },
            showInRoles: [APPLICANT],
            showInFormCreate: true,
            showInTab: [PostApprovalFormType.FORM],
            condition: () => {
                // if hasCCOAction === true, it should show Re-submit instead

                if (hasCCOAction) {
                    return null;
                }

                //case of view only of applicant
                // if (userRole === APPLICANT && status === RETURNED) {
                //     return hasPermission;
                // }

                return !isViewOnly;
            },
        },
        {
            text: 'Re-submit', // this is the case of "RETURN_FROM_IRB"
            status: [RETURNED],
            condition: () => {
                //case of view only of applicant
                // if (userRole === APPLICANT && status === RETURNED) {
                //     return hasPermission;
                // }

                if ([CTC, CTI].includes(documentType)) {
                    return false;
                }

                if (isViewOnly) {
                    return false;
                }

                return hasCCOAction;
            },
            action: async () => {
                const result = await checkSubmitFormValid();

                if (!result) {
                    return;
                }

                const { valid, msg } = result;
                if (!valid) {
                    return showDialog({
                        description: msg ?? PLEASE_COMPLETE_THE_FORM,
                        disableCancelButton: true,
                    });
                }
                if (!signedUpload?.fileName) {
                    return showDialog({
                        description: 'Please upload the signed document before submission',
                        disableCancelButton: true,
                    });
                }

                const isConfirm = await showDialog({
                    description: GENERAL_RE_SUBMIT_TIPS,
                });

                if (isConfirm) {
                    onSubmit({ isResubmit: false });
                }
            },
            showInRoles: [APPLICANT],
            showInTab: [PostApprovalFormType.FORM],
        },
        {
            text: 'Confirm request for return',
            status: REQUEST_FOR_RETURN,
            action: async () => {
                const { submit, comment, expiryDate } = await showCommentDialog({
                    title: CONFIRM_REQUEST_TO_RETURN_CONFIRM,
                    placeholder: 'Leave your comments',
                    isRequired: true,
                    showExpiryDate: true,
                });

                if (!submit) {
                    return;
                }

                setGlobalLoading(true);

                returnDocument({ comment, expiryDate, status: RETURNED })
                    .then((res) => {
                        showDialog({
                            description: GENERAL_RETURN_SUCCESS,
                            disableCancelButton: true,
                        });

                        history.push('/');
                    })
                    .finally(() => {
                        setGlobalLoading(false);
                    });
            },
            showInRoles: [CCO, SECRETARY],
            showInTab: [PostApprovalFormType.FORM],
        },
        {
            text: 'Distribute',
            status: [SUBMITTED, RE_SUBMITTED],
            condition: () => {
                if (hasCCOAction) {
                    return false;
                }

                return true;
            },
            action: async () => {
                const { submit, comment, fileIds, cluster } = await showCommentDialog({
                    title: GENERAL_DISTRIBUTE_TIPS,
                    placeholder: 'Leave your comments (if any)',
                    showUploadButton: true,
                    isRequired: false,
                    showClusterSelect: true,
                });

                if (!submit) {
                    return;
                }

                setGlobalLoading(true);

                distributeDocument({ comment, uploadTempId: fileIds, cluster, status: DISTRIBUTED })
                    .then((res) => {
                        showDialog({
                            description: GENERAL_DISTRIBUTE_SUCCESS,
                            disableCancelButton: true,
                        });
                        history.push('/');
                    })
                    .finally(() => {
                        setGlobalLoading(false);
                    });
            },
            showInRoles: [CCO],
            showInTab: [PostApprovalFormType.FORM],
        },
        {
            text: 'Verify',
            status: [DISTRIBUTED],
            action: async () => {
                const { submit, comment, fileIds } = await showCommentDialog({
                    title: GENERAL_VERIFY_TIPS,
                    placeholder: 'Leave your comments (if any)',
                    isRequired: false,
                    showUploadButton: true,
                });

                if (!submit) {
                    return;
                }

                setGlobalLoading(true);

                updateStatus({ comment, uploadTempId: fileIds, status: VERIFIED })
                    .then((res) => {
                        showDialog({
                            description: GENERAL_VERIFY_SUCCESS,
                            disableCancelButton: true,
                        });
                        history.push('/');
                    })
                    .finally(() => {
                        setGlobalLoading(false);
                    });
            },
            showInRoles: [CLUSTER_ADMIN],
            showInTab: [PostApprovalFormType.FORM],
        },
        {
            text: 'Reject request for return',
            status: [REQUEST_FOR_RETURN],
            action: async () => {
                const { submit, comment, fileIds } = await showCommentDialog({
                    title: REJECT_RETURN_OF_REQUEST_TIPS,
                    placeholder: 'Leave your comments',
                    isRequired: true,
                    showUploadButton: true,
                });

                if (!submit) {
                    return;
                }

                setGlobalLoading(true);

                rejectRequestForRequest({ comment, uploadTempId: fileIds })
                    .then((res) => {
                        showDialog({
                            description: REJECT_SUCCESS,
                            disableCancelButton: true,
                        });
                        history.push('/');
                    })
                    .finally(() => {
                        setGlobalLoading(false);
                    });
            },
            showInRoles: [CCO, SECRETARY],
            showInTab: [PostApprovalFormType.FORM],
        },
        {
            text: 'Confirm',
            status: [SUBMITTED, VERIFIED, RE_SUBMITTED, DISTRIBUTED],
            condition: () => {
                let isValid = true;

                if (status === DISTRIBUTED && userRole !== SECRETARY) {
                    isValid = false;
                }

                return isValid;
            },
            action: async () => {
                const { submit, comment, fileIds } = await showCommentDialog({
                    title: GENERAL_CONFIRM,
                    placeholder: 'Leave your comments (if any)',
                    isRequired: false,
                    showUploadButton: true,
                });

                if (!submit) {
                    return;
                }

                setGlobalLoading(true);

                updateStatus({ comment, uploadTempId: fileIds, status: CONFIRMED })
                    .then((res) => {
                        showDialog({
                            description: GENERAL_CONFIRM_SUCCESS,
                            disableCancelButton: true,
                        });
                        history.push('/');
                    })
                    .finally(() => {
                        setGlobalLoading(false);
                    });
            },
            showInRoles: [CCO, SECRETARY],
            showInTab: [PostApprovalFormType.FORM],
        },
        {
            text: 'Return',
            status: [SUBMITTED, RE_SUBMITTED, FOR_REVIEW, REVIEWED, VERIFIED, DISTRIBUTED, RETURN_FROM_IRB, CONFIRMED],
            condition: () => returnCondition(userRole, status),
            action: async () => {
                const { submit, comment, expiryDate, fileIds } = await showCommentDialog({
                    title: status === VERIFIED ? CONFIRM_RETURN_TO_CLUSTER_ADMIN : GENERAL_RETURN_TIPS,
                    placeholder: 'Leave your comments (if any)',
                    isRequired: false,
                    showExpiryDate: status === VERIFIED ? false : true,
                    defaultExpiryDate: '',
                    showUploadButton: true,
                });

                if (!submit) {
                    return;
                }

                setGlobalLoading(true);

                const postData = { comment, uploadTempId: fileIds, status: RETURNED };

                // if status === verified, cco will return application to cluster only, no need expiry date in this case
                if (status !== VERIFIED) {
                    postData.expiryDate = expiryDate;
                }

                returnDocument(postData)
                    .then((res) => {
                        showDialog({
                            description: GENERAL_RETURN_SUCCESS,
                            disableCancelButton: true,
                        });
                        history.push('/');
                    })
                    .finally(() => {
                        setGlobalLoading(false);
                    });
            },
            showInRoles: [CCO, SECRETARY, CLUSTER_ADMIN],
            showInTab: [PostApprovalFormType.FORM],
        },
        {
            text: 'Return', // this is the case of "RETURN_FROM_IRB"
            status: [FOR_REVIEW, REVIEWED, CONFIRMED],
            action: async () => {
                const { submit, comment, expiryDate, fileIds } = await showCommentDialog({
                    title: GENERAL_RETURN_TIPS,
                    placeholder: 'Leave your comments (if any)',
                    isRequired: false,
                    showExpiryDate: true,
                    defaultExpiryDate: '',
                    showUploadButton: true,
                });

                if (!submit) {
                    return;
                }

                setGlobalLoading(true);

                returnDocument({ comment, uploadTempId: fileIds, expiryDate, status: RETURN_FROM_IRB })
                    .then((res) => {
                        showDialog({
                            description: GENERAL_RETURN_SUCCESS,
                            disableCancelButton: true,
                        });
                        history.push('/');
                    })
                    .finally(() => {
                        setGlobalLoading(false);
                    });
            },
            showInRoles: [IRB],
            showInTab: [PostApprovalFormType.FORM],
        },
        {
            text: !status ? 'Discard' : status === DRAFT ? 'Discard' : 'Withdraw',
            status: [RETURNED, DRAFT, EXPIRED],
            condition: () => {
                //case of view only of applicant
                // if (userRole === APPLICANT && status === RETURNED) {
                //     return hasPermission;
                // }
                return !isViewOnly;
            },
            action: async () => {
                let isSubmit = false;
                let comment = '';

                if (status === DRAFT) {
                    isSubmit = await showDialog({
                        description: POST_APPROVAL_DISCARD_TIPS,
                    });
                } else {
                    const { submit, comment: commentRes } = await showCommentDialog({
                        title: GENERAL_WITHDRAWN_TIPS,
                        placeholder: 'Please state the reason(s).',
                    });

                    isSubmit = submit;
                    comment = commentRes;
                }

                if (!isSubmit) {
                    return;
                }

                setGlobalLoading(true);

                const postData = { status: WITHDRAWN };

                if (comment) {
                    postData.comment = comment;
                }

                updateStatus(postData)
                    .then((res) => {
                        showDialog({
                            description: status === DRAFT ? POST_APPROVAL_DISCARD_SUCCESS : GENERAL_WITHDRAWN_SUCCESS,
                            disableCancelButton: true,
                        });
                        history.push('/');
                    })
                    .finally(() => {
                        setGlobalLoading(false);
                    });
            },
            showInRoles: [APPLICANT],
            showInTab: [PostApprovalFormType.FORM],
        },
        // {
        //     text: 'Terminate',
        //     status: [APPROVED],
        //     action: async () => {
        //         const { submit, comment, fileIds } = await showCommentDialog({
        //             title: GENERAL_TERMINATE_TIPS,
        //             placeholder: 'Please state the reason(s).',
        //             showUploadButton: true,
        //         });

        //         if (!submit) {
        //             return;
        //         }

        //         setGlobalLoading(true);

        //         updateStatus({ comment, uploadTempId: fileIds, status: TERMINATED })
        //             .then((res) => {
        //                 showDialog({
        //                     description: GENERAL_TERMINATE_SUCCESS,
        //                     disableCancelButton: true,
        //                 });
        //                 history.push('/');
        //             })
        //             .finally(() => {
        //                 setGlobalLoading(false);
        //             });
        //     },
        //     showInRoles: [SECRETARY, IRB],
        //     showInTab: [PostApprovalFormType.FORM],
        // },
        {
            text: 'Confirm Review Result',
            status: [FOR_REVIEW],
            action: async () => {
                history.push(
                    `/post-approval-document/confirm-review-result?appId=${reportId}&documentType=${documentType}`,
                );
            },
            showInRoles: [REVIEWER],
            showInTab: [PostApprovalFormType.FORM],
        },
        {
            text: 'Save', // save button for saving consolidation
            tag: 'consolidation-save',
            status: consolidationStatus,
            condition: () => {
                return true;
            },
            action: async () => {
                dispatch({
                    type: SAVE_CONSOLIDATION_DETAIL,
                    payload: {
                        formId: reportId,
                        documentType,
                        callback: () => {
                            showDialog({
                                description: CONSOLIDATION_SAVED,
                                disableCancelButton: true,
                            });
                        },
                    },
                });
            },
            showInRoles: [IRB, SECRETARY],
            showInTab: TAB_CONSOLIDATION,
        },
        {
            text: 'Confirm', // confirm button for confirming consolidation
            tag: 'consolidation-confirm',
            status: consolidationStatus,
            condition: () => {
                return postApprovalPermissionChecking({ currentTab, status });
            },
            action: async () => {
                dispatch({
                    type: SUBMIT_CONSOLIDATION_DETAIL,
                    payload: {
                        isPostApproval: true,
                        formId: reportId,
                        documentType,
                        showDialog,
                        callback: () => {
                            showDialog({
                                description: GENERAL_CONSOLIDATION_SUCCESS,
                                disableCancelButton: true,
                            });
                            history.push('/');
                        },
                    },
                });
            },
            showInRoles: [IRB, SECRETARY],
            showInTab: TAB_CONSOLIDATION,
        },
        {
            text: 'Download Approval Letter', // button for consolidation Download Approval Letter
            tag: 'download-approval-letter',
            status: consolidationStatus,
            action: async () => {
                dispatch({
                    type: DOWNLOAD_APPROVAL_LETTER,
                    payload: {
                        formId: reportId,
                        showDialog,
                        msg: systemMessage.warnChoseDecision,
                        documentType,
                    },
                });
            },
            condition: () => {
                return postApprovalPermissionChecking({ currentTab, status });
            },
            showInRoles: [IRB, SECRETARY],
            showInTab: TAB_CONSOLIDATION,
        },
        {
            text: 'Re-Submit', // button for CTC/CTI Submission when status = returned
            status: [RETURNED],
            action: async () => {
                reSubmitCTCAndCTI();
            },
            condition: () => {
                return !isViewOnly && [CTC, CTI].includes(documentType);
            },
            showInRoles: [APPLICANT],
            showInTab: [PostApprovalFormType.FORM],
        },
        {
            text: formTab === PostApprovalFormType.FORM ? 'Close' : 'Back to form',
            // status: [],
            action: async () => {
                if (checkIsFormDataChanged()) {
                    const isConfirm = await showDialog({ description: DISCARD_CONFIRM });

                    if (!isConfirm) {
                        return;
                    }
                }

                if ([PostApprovalFormType.COMMENT, TAB_CONSOLIDATION, TAB_REVIEWER_COMMENT].includes(formTab)) {
                    return switchToTab(PostApprovalFormType.FORM);
                } else {
                    // if path is come from search page, go back to search page
                    if (getItem(KEY_PATHNAME) === '/search') {
                        dispatch(
                            setGlobal({
                                isDetailBack: true,
                            }),
                        );
                        history.push('/search');
                    } else {
                        const url = getFolderDisplayPath(userRole, status);

                        let extraQuery = '';

                        if (url !== `/${postApprovalFolder}`) {
                            extraQuery = '?page=1';
                        }

                        history.push('/post-approval-document' + url + extraQuery);
                    }
                }
            },
            type: 'cancel',
            // showInRoles: [APPLICANT],
        },
        {
            text: 'Download signed document',
            disableInForm: [CTC, CTI],
            condition: () => {
                if (signedUpload?.fileName) {
                    return true;
                }
                return false;
            },
            fileName: signedUpload?.fileName,
            key: signedUpload?.key,
            file: signedUpload?.file,
            showInTab: [PostApprovalFormType.FORM],
        },
    ];

    if (userRole !== APPLICANT) {
        const index = result.findIndex((item) => item.type === 'cancel');
        const btn = result[index];
        result.splice(index, 1);
        result.push(btn);
    }

    return result.filter((item) => {
        // if showInRoles is not specified, show in all roles
        if (!item.showInRoles) {
            return true;
        }

        return item?.showInRoles?.includes(userRole);
    });
};

export default useGeneralPostApprovalButton;
